// Core
import styled from 'styled-components';

export const MotorControlContainer = styled.div`
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  border-radius: 4px;
  display: flex;
`;
